{
	"medal": {
		"GOLD": "Gold",
		"SILVER": "Silver",
		"BRONZE": "Bronze"
	},
	"state": {
		"NOT_SCHEDULED": "Not scheduled",
		"COMPETING": "Competing",
		"WAITING": "Waiting for the desk",
		"AWARDED": "Awarded",
		"NO_MEDALS": "No medals"
	},
	"noGames": {
		"title": "No games yet",
		"body": "Medals show here once a games is set up in GMS."
	},
	"filters": {
		"sport": "Sport",
		"allSports": "All sports",
		"noc": "NOC",
		"allNocs": "All NOCs"
	},
	"list": {
		"title": "Awarded medals",
		"subtitle": "{{games}}. Every medal the desk awarded, newest first.",
		"medal": "Medal",
		"event": "Event",
		"competitor": "Athlete or team",
		"awarded": "Awarded",
		"empty": "No medal has been awarded in this games yet.",
		"emptyFiltered": "No medal matches this sport and NOC yet.",
		"showing_one": "Showing {{n}} medal",
		"showing_other": "Showing {{n}} medals",
		"allLoaded": "All medals are shown."
	},
	"tally": {
		"title": "Medal tally",
		"titleInSport": "Medal tally: {{sport}}",
		"subtitle": "{{games}}. Ranked by gold, then silver, then bronze; tied NOCs share a rank. Open a NOC to see its medals.",
		"rank": "Rank",
		"noc": "NOC",
		"total": "Total",
		"open": "Show the medals of {{noc}}",
		"empty": "No NOC has a competitor entered here yet."
	},
	"progress": {
		"label": "Medal progress",
		"ofTotal": "{{n}} of {{total}}",
		"decided": "Medal events decided",
		"decidedDetail": "{{awarded}} awarded · {{none}} with no medals",
		"waiting": "Waiting for the desk",
		"waitingDetail": "Every medal meet official, not awarded yet",
		"open": "Still to finish",
		"openDetail": "{{competing}} under way · {{notScheduled}} with no medal meet yet",
		"medals": "Medals awarded",
		"medalsDetail_one": "{{n}} medal still to award",
		"medalsDetail_other": "{{n}} medals still to award",
		"bySport": "Progress by sport",
		"bySportSubtitle": "Every medal event of the programme, by where it stands. Waiting is the medal desk's queue.",
		"allSports": "All sports",
		"decidedOf": "{{n}} of {{total}} decided",
		"empty": "No sport has a medal event yet.",
		"col": {
			"sport": "Sport",
			"events": "Medal events",
			"awarded": "Awarded",
			"waiting": "Waiting",
			"competing": "Under way",
			"notScheduled": "Not scheduled",
			"noMedals": "No medals",
			"medalsAwarded": "Medals awarded",
			"medalsToAward": "Still to award"
		}
	}
}
